module.exports = __webpack_public_path__ + "img/Cutlery Icon - charcoal.51254565.svg";